import Mosaic from './Mosaic';
import SkeletonMosaic from './Mosaic.skeleton';
import MosaicDestacats from './MosaicDestacats';
import MosaicPoster from './MosaicPoster';

export default function Component(props) {
    const { isLoading, tipus } = props;
    return isLoading ? (
        <SkeletonMosaic {...props} />
    ) : tipus === 'destacat' ? (
        <MosaicDestacats {...props} />
    ) : tipus === 'poster' ? (
        <MosaicPoster {...props} />
    ) : (
        <Mosaic {...props} />
    );
}
export { MoreItemsButton } from './Mosaic';
